import type { Choice } from "@memorang/types";
import type { IconType } from "@memorang/ui/icon";
import concat from "lodash/concat";

const scorePerAttempt = [10, 5, 3, 2, 1];
const getSortedChoices = (choiceList: Choice[]) => {
	const correctChoices = choiceList.filter(({ isCorrect }) => isCorrect);
	const incorrectChoices = choiceList.filter(({ isCorrect }) => !isCorrect);
	return concat(correctChoices, incorrectChoices);
};
const calculateXp = (numAttempts: number, isHintShown: boolean) => {
	const score = scorePerAttempt[numAttempts - 1] || 0;
	return isHintShown ? score : score * 2;
};
export const learningModeIcon: Record<string, IconType> = {
	flip: "cards-outline",
	quiz: "format-list-checks",
	match: "checkerboard",
	questionSet: "format-list-checks",
	simulations: "call-split",
	questions: "order-bool-descending",
	writing: "pencil-outline",
	listening: "ear-hearing",
	speaking: "microphone-outline",
	reading: "book-open-page-variant-outline",
};
export { getSortedChoices, calculateXp };
